import React, { useState } from 'react';
import { useAsync } from 'react-use';
import services from 'services';
import { useField } from 'formik';
import styled from 'styled-components/macro';
import IntlHelper from 'utils/helpers/intl.helper';
import Header from 'components/Modal/Header';
import CommonButton from 'components/Buttons/CommonButton';
import { FatherContracts } from 'models/response';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'components/Table';
import actions from 'state/actions';
import selectors from 'state/selectors';
import { FormData } from '../../pdf/bottom';

const TableContainer = styled.div`
  width: 1200px;
  .table-pagination {
    justify-content: center;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  button {
    margin: 0 5px;
  }
`;

const ChildOf = () => {
  const modalProps = useSelector(selectors.modal.getModalProps);
  const t = IntlHelper.useTranslator();
  const dispatch = useDispatch();
  const [fatherContracts, setFatherContracts] = useState<FatherContracts[]>([]);
  const [selectedRow, setSelectedRow] = useState<FatherContracts | null>(null);
  const [fieldCompany] = useField<FormData['company']>('company');
  const [fieldSubject] = useField<FormData['subject']>('subject');
  const [, , helpersFieldIdParent] = useField<FormData['idParent']>('idParent');

  const columns = [
    {
      Header: t('subject'),
      accessor: 'subject',
    },
    {
      Header: t('mallAddress'),
      accessor: 'mallAddress',
    },
    {
      Header: t('mallCity'),
      accessor: 'mallCity',
    },
    {
      Header: t('mallName'),
      accessor: 'mallName',
    },
    {
      Header: t('mallPostalCode'),
      accessor: 'mallPostalCode',
    },
    {
      Header: t('mallProvince'),
      accessor: 'mallProvince',
    },
    {
      Header: t('startDate'),
      accessor: 'startDate',
    },
    {
      Header: t('endDate'),
      accessor: 'endDate',
    },
  ];

  useAsync(async () => {
    if (fieldCompany.value && fieldSubject.value) {
      try {
        const { data } = await services.getFatherContracts(fieldCompany.value.value, fieldSubject.value.value);
        setFatherContracts(data);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  const onSelection = (rows: FatherContracts[]) => {
    setSelectedRow(rows[0]);
  };

  const setFather = async (protocolFather: number) => {
    helpersFieldIdParent.setValue(protocolFather);
    modalProps.func({ ...modalProps.values, idParent: protocolFather });
  };

  const saveRecord = () => {
    if (selectedRow) {
      setFather(selectedRow.protocol);
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <>
      <Header title={t('fatherContractsTitle')} subtitle={t('fatherContractsSubTitle')} />
      <TableContainer>
        {fatherContracts ? (
          <Table
            id="father-contracts-table"
            rowId="idWSubject"
            hasSort
            columns={columns}
            rows={fatherContracts}
            onSelection={onSelection}
            onRowDoubleClick={saveRecord}
            hasSelection
            hasPagination
            hasResize
          />
        ) : null}
      </TableContainer>
      <ButtonsContainer>
        <CommonButton
          id="child-of-modal-confirm"
          scope="primary"
          value={t('confirm')}
          type="button"
          disabled={!selectedRow}
          action={() => saveRecord()}
        />
        <CommonButton
          id="child-of-modal-cancel"
          scope="secondary"
          value={t('cancel')}
          type="button"
          action={() => dispatch(actions.modal.closeModal())}
        />
      </ButtonsContainer>
    </>
  );
};

export default ChildOf;
